import { useState } from "react";
import api from "../utilis/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../redux/store/userSlice";

export const LoginModal = ({ setTab, onClose }) => {
  const [loginForm, setLoginForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputStyle = {
    width: "100%",
    border: "1px solid #ddd",
    borderRadius: "10px",
    padding: "10px 14px",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    transition: "border-color 0.2s",
  };

  const goldBtn = {
    width: "100%",
    background: "#b38f36",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "12px",
    fontWeight: 700,
    fontSize: "15px",
    cursor: "pointer",
    marginTop: "8px",
    letterSpacing: "0.03em",
    transition: "background 0.2s",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate form data
      if (!loginForm.email?.trim() || !loginForm.password?.trim()) {
        toast.error("Please fill in all fields", { autoClose: 3000 });
        return;
      }

      const response = await api.post("/auth/sign-in", {
        email: loginForm.email.trim(),
        password: loginForm.password
      });

      if (response.data?.meta?.success) {
        const user = response.data.data.user;
        const token = response.data.data.token;

        // Check if user is admin (should use admin login)
        if (user.role === "admin") {
          toast.error("Admin accounts must login via the admin page.", {
            autoClose: 4000,
          });
          return;
        }

        // Dispatch login action
        dispatch(login({ user, token }));
        
        toast.success(`Welcome back, ${user.name}!`, { autoClose: 2000 });
        
        // Close modal if onClose function is provided
        if (onClose) {
          onClose();
        }
        
        // Navigate to user dashboard
        setTimeout(() => {
          navigate("/user", { replace: true });
        }, 100);
        
      } else {
        toast.error(response.data?.meta?.message || "Login failed", {
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error('User login error:', error);
      const message =
        error?.response?.data?.meta?.message ||
        error?.response?.data?.message ||
        error.message ||
        "Network error. Please check your connection.";
      toast.error(message, { autoClose: 5000 });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "14px",
      }}
    >
      <div>
        <label
          style={{
            fontSize: "12px",
            fontWeight: 600,
            color: "#555",
            display: "block",
            marginBottom: "6px",
            textTransform: "uppercase",
            letterSpacing: "0.06em",
          }}
        >
          Email
        </label>
        <input
          type="email"
          style={inputStyle}
          placeholder="hello@example.com"
          value={loginForm.email}
          onChange={(e) =>
            setLoginForm((f) => ({ ...f, email: e.target.value }))
          }
          onFocus={(e) => (e.target.style.borderColor = "#b38f36")}
          onBlur={(e) => (e.target.style.borderColor = "#ddd")}
        />
      </div>
      <div>
        <label
          style={{
            fontSize: "12px",
            fontWeight: 600,
            color: "#555",
            display: "block",
            marginBottom: "6px",
            textTransform: "uppercase",
            letterSpacing: "0.06em",
          }}
        >
          Password
        </label>
        <input
          type="password"
          style={inputStyle}
          placeholder="••••••••"
          value={loginForm.password}
          onChange={(e) =>
            setLoginForm((f) => ({ ...f, password: e.target.value }))
          }
          onFocus={(e) => (e.target.style.borderColor = "#b38f36")}
          onBlur={(e) => (e.target.style.borderColor = "#ddd")}
        />
      </div>
      <div style={{ textAlign: "right" }}>
        <button
          onClick={() => setTab("forgot-password")}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "12px",
            color: "#b38f36",
            fontWeight: 500,
          }}
        >
          Forgot password?
        </button>
      </div>
      <button
        style={goldBtn}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#8e712a")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "#b38f36")}
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "Signing In..." : "Sign In"}
      </button>
      <p
        style={{
          textAlign: "center",
          fontSize: "13px",
          color: "#888",
          margin: "4px 0 0",
        }}
      >
        Don't have an account?{" "}
        <button
          onClick={() => setTab("register")}
          style={{
            background: "none",
            border: "none",
            color: "#b38f36",
            fontWeight: 600,
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          Register
        </button>
      </p>
    </div>
  );
};

export const RegisterModal = ({ setTab }) => {
  const [registerForm, setRegisterForm] = useState({
    name: "",
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const inputStyle = {
    width: "100%",
    border: "1px solid #ddd",
    borderRadius: "10px",
    padding: "10px 14px",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    transition: "border-color 0.2s",
  };

  const goldBtn = {
    width: "100%",
    background: "#b38f36",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "12px",
    fontWeight: 700,
    fontSize: "15px",
    cursor: "pointer",
    marginTop: "8px",
    letterSpacing: "0.03em",
    transition: "background 0.2s",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const register = await api.post("/auth/sign-up", registerForm);
      console.log(register.data);
      if (register.data) {
        toast.success("User registered successfully");

        setTimeout(() => {
          setTab("login");
        }, 1500);
      } else {
        toast.error(register.data?.meta?.message || "Registration failed", {
          autoClose: 4000,
        });
      }

      setRegisterForm({
        name: "",
        email: "",
        password: "",
      });
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Something went wrong";
      toast.error(message, { autoClose: 5000 });
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "14px",
      }}
    >
      <div>
        <label
          style={{
            fontSize: "12px",
            fontWeight: 600,
            color: "#555",
            display: "block",
            marginBottom: "6px",
            textTransform: "uppercase",
            letterSpacing: "0.06em",
          }}
        >
          Full Name
        </label>
        <input
          type="text"
          style={inputStyle}
          placeholder="John Doe"
          value={registerForm.name}
          onChange={(e) =>
            setRegisterForm((f) => ({ ...f, name: e.target.value }))
          }
          onFocus={(e) => (e.target.style.borderColor = "#b38f36")}
          onBlur={(e) => (e.target.style.borderColor = "#ddd")}
        />
      </div>
      <div>
        <label
          style={{
            fontSize: "12px",
            fontWeight: 600,
            color: "#555",
            display: "block",
            marginBottom: "6px",
            textTransform: "uppercase",
            letterSpacing: "0.06em",
          }}
        >
          Email
        </label>
        <input
          type="email"
          style={inputStyle}
          placeholder="hello@example.com"
          value={registerForm.email}
          onChange={(e) =>
            setRegisterForm((f) => ({ ...f, email: e.target.value }))
          }
          onFocus={(e) => (e.target.style.borderColor = "#b38f36")}
          onBlur={(e) => (e.target.style.borderColor = "#ddd")}
        />
      </div>
      <div>
        <label
          style={{
            fontSize: "12px",
            fontWeight: 600,
            color: "#555",
            display: "block",
            marginBottom: "6px",
            textTransform: "uppercase",
            letterSpacing: "0.06em",
          }}
        >
          Password
        </label>
        <input
          type="password"
          style={inputStyle}
          placeholder="••••••••"
          value={registerForm.password}
          onChange={(e) =>
            setRegisterForm((f) => ({
              ...f,
              password: e.target.value,
            }))
          }
          onFocus={(e) => (e.target.style.borderColor = "#b38f36")}
          onBlur={(e) => (e.target.style.borderColor = "#ddd")}
        />
      </div>
      <button
        style={goldBtn}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#8e712a")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "#b38f36")}
        onClick={handleSubmit}
      >
        Create Account
      </button>
      <p
        style={{
          textAlign: "center",
          fontSize: "13px",
          color: "#888",
          margin: "4px 0 0",
        }}
      >
        Already have an account?{" "}
        <button
          onClick={() => setTab("login")}
          style={{
            background: "none",
            border: "none",
            color: "#b38f36",
            fontWeight: 600,
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          Login
        </button>
      </p>
    </div>
  );
};

export const ForgotPasswordModal = ({ setTab }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const inputStyle = {
    width: "100%",
    border: "1px solid #ddd",
    borderRadius: "10px",
    padding: "10px 14px",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    transition: "border-color 0.2s",
  };

  const goldBtn = {
    width: "100%",
    background: "#b38f36",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "12px",
    fontWeight: 700,
    fontSize: "15px",
    cursor: "pointer",
    marginTop: "8px",
    letterSpacing: "0.03em",
    transition: "background 0.2s",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!email?.trim()) {
        toast.error("Please enter your email address", { autoClose: 3000 });
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email.trim())) {
        toast.error("Please enter a valid email address", { autoClose: 3000 });
        return;
      }

      
      const response = await api.post("/auth/forgot-password", {
        email: email.trim()
      });

      if (response.data?.meta?.success) {
        setEmailSent(true);
        toast.success("Password reset instructions sent to your email!", { autoClose: 4000 });
      } else {
        console.log("❌ API Error:", response.data?.meta?.message);
        toast.error(response.data?.meta?.message || "Failed to send reset email", { autoClose: 4000 });
      }
      
    } catch (error) {
      console.error('❌ Forgot password error:', error);
      const message = error?.response?.data?.meta?.message || 
                     error?.response?.data?.message || 
                     error.message || 
                     "Failed to send reset email. Please try again.";
      toast.error(message, { autoClose: 4000 });
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <div style={{ 
          width: "60px", 
          height: "60px", 
          background: "linear-gradient(135deg, #b38f36, #8e712a)",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 20px",
          fontSize: "24px"
        }}>
          ✉️
        </div>
        <h3 style={{ 
          fontSize: "18px", 
          fontWeight: 600, 
          color: "#333", 
          marginBottom: "12px" 
        }}>
          Check Your Email
        </h3>
        <p style={{ 
          fontSize: "14px", 
          color: "#666", 
          lineHeight: "1.5", 
          marginBottom: "20px" 
        }}>
          We've sent password reset instructions to <strong>{email}</strong>
        </p>
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={() => {
              setEmailSent(false);
              setEmail("");
            }}
            style={{
              flex: 1,
              padding: "10px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              background: "white",
              color: "#666",
              fontSize: "13px",
              cursor: "pointer"
            }}
          >
            Try Again
          </button>
          <button
            onClick={() => setTab("login")}
            style={{
              flex: 1,
              padding: "10px",
              border: "none",
              borderRadius: "8px",
              background: "#b38f36",
              color: "white",
              fontSize: "13px",
              cursor: "pointer"
            }}
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        <div style={{ 
          width: "50px", 
          height: "50px", 
          background: "linear-gradient(135deg, #b38f36, #8e712a)",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 15px",
          fontSize: "20px"
        }}>
          🔐
        </div>
        <h3 style={{ fontSize: "18px", fontWeight: 600, color: "#333", marginBottom: "8px" }}>
          Forgot Password?
        </h3>
        <p style={{ fontSize: "13px", color: "#666", lineHeight: "1.4" }}>
          Enter your email address and we'll send you instructions to reset your password.
        </p>
      </div>

      <div>
        <label style={{
          fontSize: "12px",
          fontWeight: 600,
          color: "#555",
          display: "block",
          marginBottom: "6px",
          textTransform: "uppercase",
          letterSpacing: "0.06em",
        }}>
          Email Address
        </label>
        <input
          type="email"
          style={inputStyle}
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onFocus={(e) => (e.target.style.borderColor = "#b38f36")}
          onBlur={(e) => (e.target.style.borderColor = "#ddd")}
          disabled={loading}
        />
      </div>

      <button
        style={{
          ...goldBtn,
          opacity: loading ? 0.7 : 1,
          cursor: loading ? "not-allowed" : "pointer"
        }}
        onMouseEnter={(e) => !loading && (e.currentTarget.style.background = "#8e712a")}
        onMouseLeave={(e) => !loading && (e.currentTarget.style.background = "#b38f36")}
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "Sending..." : "Send Reset Instructions"}
      </button>

      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <button
          onClick={() => setTab("login")}
          style={{
            background: "none",
            border: "none",
            color: "#b38f36",
            fontWeight: 600,
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          ← Back to Login
        </button>
      </div>
    </div>
  );
};